import styled from 'styled-components';

const OrdersNewStyleWrapper = styled.div`
  .isoExampleWrapper {
    margin-top: 0px;
  }

  h2 {
    font-size: 14px;
    font-weight: 500;
    color: #323332;
    margin: 0;
    margin-bottom: 5px;
  }

  p {
    font-size: 13px;
    font-weight: 400;
    color: #797979;
    line-height: 24px;
  }

  .productControl {
    display: flex;
    align-items: center;
    justify-content: flex-start;

    button {
      font-size: 16px;
      color: #2d3446;
      width: 35px;
      height: 35px;
      display: flex;
      align-items: center;
      text-align: center;
      justify-content: center;
      background-color: #ffffff;
      outline: 0;
      padding: 0;
      border: 1px solid #e9e9e9;
      margin-left: ${props =>
        props['data-rtl'] === 'rtl' ? 'inherit' : '-1px'};
      margin-right: ${props =>
        props['data-rtl'] === 'rtl' ? '-1px' : 'inherit'};
      cursor: pointer;
      -webkit-border-radius: 0;
      -moz-border-radius: 0;
      -ms-transition: 0;
      -o-border-radius: 0;
      border-radius: 0;
      -webkit-transition: all 0.3s cubic-bezier(0.215, 0.61, 0.355, 1);
      -moz-transition: all 0.3s cubic-bezier(0.215, 0.61, 0.355, 1);
      -ms-transition: all 0.3s cubic-bezier(0.215, 0.61, 0.355, 1);
      -o-transition: all 0.3s cubic-bezier(0.215, 0.61, 0.355, 1);
      transition: all 0.3s cubic-bezier(0.215, 0.61, 0.355, 1);

      i {
        width: 100%;
      }

      span {
        display: none;
      }

      &:first-child {
        margin-left: ${props =>
          props['data-rtl'] === 'rtl' ? 'inherit' : '0'};
        margin-right: ${props =>
          props['data-rtl'] === 'rtl' ? '0' : 'inherit'};
      }

      &:hover {
        color: #1A73A7;
        background-color: #fcfcfc;
        border-color: #e9e9e9;
      }
    }
  }
`;

export default OrdersNewStyleWrapper;


// WEBPACK FOOTER //
// ./src/components/Orders/ordersNew.style.js